import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { exportClientsCSVFile } from "store/services/clientService";
import { ERROR_MESSAGE } from "common/constantMessage";
import { useShowLoader } from "hooks/useShowLoader";
import { FULL_NAME } from "helpers/common";
import { ReactComponent as OTick } from "Assets/Images/icn/OrangeTick.svg";
import { getExportClientsList } from "store/services/accountSettingService";


export default function ExportWizardPopup({ dispatch, showPopup, closePopup, addExportRequest }) {
  const showLoader = useShowLoader();
  const [currentStep, setCurrentStep] = useState(1);
  const [exportType, setExportType] = useState("CSV");
  const [exportAllClients, setExportAllClients] = useState(true);
  const [clientList, setClientList] = useState(null);
  const [selectedClients, setSelectedClients] = useState([]);

  useEffect(() => {
    if (currentStep === 3 && !clientList) {
      getClientList();
    }
  }, [currentStep]);

  // const validationSchema = useMemo(() => {
  //   if(!userDetail) {
  //     return Yup.object();
  //   }

  //   return Yup.object().shape({
  //     reason: stringRequired("Reason", { min: 50, max: 250 }),
  //     user_name: Yup.string()
  //       .lowercase()
  //       .required(`To confirm, please enter your account email.`)
  //       .oneOf([userDetail?.email?.toLowerCase()], "The entered email does not match. Please enter the correct email to proceed."),
  //   });
  // }, [userDetail]);

  // const formik = useFormik({
  //   initialValues: {
  //     reason: "",
  //     user_name: ""
  //   },
  //   validationSchema: validationSchema,
  //   onSubmit: handleSubmit,
  //   enableReinitialize: true,
  // })

  // const handleClose = () => {
  //   formik.resetForm();
  //   closePopup();
  // }

  async function getClientList() {
    try {
      showLoader(true);
      let res = await getExportClientsList();
      setClientList(res?.body || null);
      showLoader(false);
    } catch (err) {
      showLoader(false);
      console.log(err);
    }
  }

  const handleClose = () => {
    setCurrentStep(1);
    setExportType("CSV");
    setExportAllClients(true);
    setSelectedClients([]);
    setClientList(null);
    closePopup();
  }

  const handleExportCSV = async () => {
    try {
      showLoader(true);
      const newTab = window.open('', '_blank');
      newTab.document.writeln('<p>Please wait...</p>');
      try {
        const response = await exportClientsCSVFile();
        if (!response) {
          ERROR_MESSAGE("Failed to export clients");
          throw new Error("CSV response was not valid");
        }
        if (response?.body?.url) {
          newTab.location.href = response?.body?.url;
          setTimeout(() => newTab.close(), 5000)
        } else {
          newTab.document.writeln('<p>Failed to load.</p>');
        }
      } catch (error) {
        console.error('Error fetching the URL:', error);
        newTab.document.writeln('<p>Error loading the URL.</p>');
      }

      handleClose();
    } catch (err) {
      console.error("Error downloading csv export", err);
    } finally {
      showLoader(false);
    }
  }

  const handleSelectClient = (event) => {
    let { value, checked } = event.target;
    value = Number(value);

    setSelectedClients((prevSelected) =>
      checked
        ? [...prevSelected, value]
        : prevSelected.filter((id) => id !== value)
    );
  };

  return (
    <>
      <Modal
        show={showPopup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Export Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12">
              {currentStep === 1 ? (
                <div>
                  <div className="py-2">
                    <p className="m-0">
                      Please select the type of export you want:
                    </p>
                    <div className="py-2 d-flex align-items-start gap-10">
                      <div className="cstmInputCheckWrp radio position-relative ">
                        <input
                          type="radio"
                          name="exportType"
                          className="position-absolute w-100 h-100"
                          value={"CSV"}
                          checked={exportType === "CSV"}
                          onChange={() => {
                            setExportType("CSV");
                          }}
                        />
                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn d-none rounded-circle">
                            <OTick />
                          </span>
                        </div>
                      </div>
                      <p className=" m-0 ">Client List (CSV Format)</p>
                    </div>
                    <div className="py-2 d-flex align-items-start gap-10">
                      <div className="cstmInputCheckWrp radio position-relative ">
                        <input
                          type="radio"
                          name="exportType"
                          className="position-absolute w-100 h-100"
                          value={"CLIENT_DATA_PDF"}
                          checked={exportType === "CLIENT_DATA_PDF"}
                          onChange={() => {
                            setExportType("CLIENT_DATA_PDF");
                          }}
                        />
                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn d-none rounded-circle">
                          </span>
                        </div>
                      </div>
                      <p className="m-0 ">Clients' Submitted Data (PDF Format)</p>
                    </div>
                    <div className="py-2 d-flex align-items-start gap-10">
                      <div className="cstmInputCheckWrp radio position-relative ">
                        <input
                          type="radio"
                          name="exportType"
                          className="position-absolute w-100 h-100"
                          value={"CSV_PDF"}
                          checked={exportType === "CSV_PDF"}
                          onChange={() => {
                            setExportType("CSV_PDF");
                          }}
                        />
                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn d-none rounded-circle">
                          </span>
                        </div>
                      </div>
                      <p className="m-0 ">Both</p>
                    </div>
                  </div>
                  <Modal.Footer className="">
                    <Button
                      className="d-flex align-items-center justify-conten-center commonBtn btnSm btn-danger"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="danger"
                      className="d-flex align-items-center justify-conten-center btnSm"
                      disabled={!exportType}
                      onClick={() => {
                        if (exportType === "CSV") {
                          handleExportCSV();
                        } else if (["CLIENT_DATA_PDF", "CSV_PDF"].includes(exportType)) {
                          setCurrentStep(2);
                        }
                      }}
                    >
                      Next
                    </Button>
                  </Modal.Footer>
                </div>
              ) : currentStep === 2 ? (
                <div>
                  <div className="py-2">
                    <p className="m-0">
                      Would you like to export all clients or select specific clients?
                    </p>
                    <div className="py-2 d-flex align-items-start gap-10">
                      <div className="cstmInputCheckWrp radio position-relative ">
                        <input
                          type="radio"
                          name="exportAllClients"
                          className="position-absolute w-100 h-100"
                          value={"yes"}
                          checked={exportAllClients}
                          onChange={() => {
                            setExportAllClients(true);
                          }}
                        />
                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn d-none rounded-circle">
                            {/* <OTick /> */}
                          </span>
                        </div>
                      </div>
                      <p className="m-0">Export All Clients</p>
                    </div>
                    <div className="py-2 d-flex align-items-start gap-10">
                      <div className="cstmInputCheckWrp radio position-relative ">
                        <input
                          type="radio"
                          name="exportAllClients"
                          className="position-absolute w-100 h-100"
                          value={"no"}
                          checked={!exportAllClients}
                          onChange={() => {
                            setExportAllClients(false);
                          }}
                        />
                        <div className="cstmInputCheck h-100 w-100 rounded-circle d-flex align-items-center justify-content-center">
                          <span className="icn d-none rounded-circle">
                            {/* <OTick /> */}
                          </span>
                        </div>
                      </div>
                      <p className="m-0">Select Specific Clients</p>
                    </div>
                    {!exportAllClients && (
                      <p className="m-0 text-muted text-sm">Select clients to export at the next step.</p>
                    )}
                  </div>
                  <Modal.Footer className="">
                    <Button
                      className="d-flex align-items-center justify-conten-center commonBtn btnSm btn-danger"
                      onClick={() => setCurrentStep(1)}
                    >
                      Back
                    </Button>
                    <Button
                      type="submit"
                      variant="danger"
                      className="d-flex align-items-center justify-conten-center btnSm"
                      onClick={() => {
                        if (exportAllClients) {
                          addExportRequest(handleClose, null, exportType);
                        } else {
                          setCurrentStep(3);
                        }
                      }}
                    >
                      Next
                    </Button>
                  </Modal.Footer>
                </div>
              ) : currentStep === 3 ? (
                <div>
                  <div className="py-2">
                      <p className="m-0">
                        Select clients to export:
                      </p>
                      <p className="text-muted m-0">(Only clients with submitted reports in their account will be listed here)</p>
                      {clientList?.length > 0 && (
                        <ul className="list-unstyled px-2 pt-2">
                          {clientList?.map((client, index) => (
                            <li key={index}>
                              <div className="py-2 d-flex align-items-start gap-10">
                                <div className="cstmInputCheckWrp position-relative checkbox">
                                  <input
                                    type="checkbox"
                                    className="position-absolute w-100 h-100"
                                    value={client.id}
                                    checked={selectedClients.includes(client.id)}
                                    onChange={handleSelectClient}
                                  />
                                  <div className="cstmInputCheck h-100 w-100  d-flex align-items-center justify-content-center">
                                    <span className="icn d-none ">
                                      <OTick />
                                    </span>
                                  </div>
                                </div>
                                <p className="m-0">{FULL_NAME(client.first_name, client.last_name)} ({client.email})</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                  </div>
                  <Modal.Footer className="">
                    <Button
                      className="d-flex align-items-center justify-conten-center commonBtn btnSm btn-danger"
                      onClick={() => setCurrentStep(2)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="d-flex align-items-center justify-conten-center btnSm"
                      disabled={!selectedClients?.length}
                      onClick={() => {
                        addExportRequest(handleClose, selectedClients, exportType);
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </div>
              ) : (
                <>
                </>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}